var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn investigation-screen"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "investigation-filter-card"
  }, [_c('form', {
    staticClass: "investigation-filter-form"
  }, [_c('div', {
    staticClass: "filter-grid"
  }, [_c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "newhubs",
      "disabled": _vm.DisabledsAllFeild,
      "options": _vm.newhublist,
      "placeholder": "Enter Zone",
      "label": "hubzonename",
      "track-by": "hubzonename"
    },
    on: {
      "input": function($event) {
        _vm.callHub(_vm.newhubs)
      }
    },
    model: {
      value: (_vm.newhubs),
      callback: function($$v) {
        _vm.newhubs = $$v
      },
      expression: "newhubs"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Hub/SVC")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "hub",
      "disabled": _vm.DisabledsAllFeild,
      "options": _vm.hublist,
      "placeholder": "Enter hub",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hub')),
      expression: "errors.has('hub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("hub is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Octroi MRP")]), _vm._v(" "), _c('div', {
    staticClass: "octroi-field-group"
  }, [_c('Multiselect', {
    attrs: {
      "name": "operator",
      "disabled": _vm.DisabledsAllFeild,
      "options": _vm.operatorOptions,
      "placeholder": "-",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.operator),
      callback: function($$v) {
        _vm.operator = $$v
      },
      expression: "operator"
    }
  }), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:2'),
      expression: "'decimal:2'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('detended_days_octroi_MRP')
    },
    attrs: {
      "id": "octroi_MRP",
      "disabled": _vm.checkDisabled,
      "name": "octroi_MRP",
      "placeholder": "Amount",
      "type": "text"
    },
    model: {
      value: (_vm.octroi_MRP),
      callback: function($$v) {
        _vm.octroi_MRP = $$v
      },
      expression: "octroi_MRP"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('octroi_MRP')),
      expression: "errors.has('octroi_MRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Shipment Value is required & Enter only number.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "Status",
      "options": _vm.StatusList,
      "disabled": _vm.DisabledsAllFeild,
      "placeholder": "Select Status",
      "label": "statusname",
      "track-by": "statusname"
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Status')),
      expression: "errors.has('Status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("status is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Verification Status")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "vStatus",
      "options": _vm.vStatusList,
      "placeholder": "Select Verification Status",
      "label": "actionname",
      "disabled": _vm.DisabledsAllFeild,
      "track-by": "actionname"
    },
    model: {
      value: (_vm.vStatus),
      callback: function($$v) {
        _vm.vStatus = $$v
      },
      expression: "vStatus"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('vStatus')),
      expression: "errors.has('vStatus')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("verification status is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Pending At")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "pendingAt",
      "options": _vm.pendingAtList,
      "disabled": _vm.DisabledsAllFeild,
      "placeholder": "Select Pending At",
      "label": "buckettypename",
      "track-by": "buckettypename"
    },
    model: {
      value: (_vm.pendingAt),
      callback: function($$v) {
        _vm.pendingAt = $$v
      },
      expression: "pendingAt"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pendingAt')),
      expression: "errors.has('pendingAt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("This Field is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Shortage Type")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "shortagetype",
      "disabled": _vm.ShortageDisableds,
      "options": _vm.shortagetypes,
      "placeholder": "Select Type",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.shortagetype),
      callback: function($$v) {
        _vm.shortagetype = $$v
      },
      expression: "shortagetype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shortagetypes')),
      expression: "errors.has('shortagetypes')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Shortage Type required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Manifest Date (From/To)")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-group"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.DisabledsAllFeild,
      "type": "date"
    },
    model: {
      value: (_vm.manifestFromDate),
      callback: function($$v) {
        _vm.manifestFromDate = $$v
      },
      expression: "manifestFromDate"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.DisabledsAllFeild,
      "type": "date"
    },
    model: {
      value: (_vm.manifestToDate),
      callback: function($$v) {
        _vm.manifestToDate = $$v
      },
      expression: "manifestToDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', {
    staticClass: "label-nowrap"
  }, [_vm._v("Investigation Logged Date (From/To)")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-group"
  }, [_c('b-form-input', {
    attrs: {
      "id": "fromdate",
      "name": "fromdate",
      "disabled": _vm.DisabledsAllFeild,
      "type": "date"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "todate",
      "disabled": _vm.DisabledsAllFeild,
      "name": "todate",
      "type": "date"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "id": "bag_no",
      "disabled": _vm.DisabledsAllFeild,
      "name": "bag_no",
      "placeholder": "Enter Bag No"
    },
    model: {
      value: (_vm.bag_no),
      callback: function($$v) {
        _vm.bag_no = $$v
      },
      expression: "bag_no"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Priority")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "priority",
      "options": _vm.priorityOptions,
      "disabled": _vm.DisabledsAllFeild,
      "label": "label",
      "track-by": "label",
      "placeholder": "Select Priority"
    },
    model: {
      value: (_vm.priority),
      callback: function($$v) {
        _vm.priority = $$v
      },
      expression: "priority"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Investigation Status")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "investigationStatus",
      "options": _vm.investigationStatusOptions,
      "disabled": _vm.DisabledsAllFeild,
      "placeholder": "Select Status",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.investigationStatus),
      callback: function($$v) {
        _vm.investigationStatus = $$v
      },
      expression: "investigationStatus"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "filter-footer"
  }, [_c('div', {
    staticClass: "awb-field"
  }, [_c('label', [_vm._v("AWB Number")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }],
    staticClass: "form-control awb-textarea",
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "placeholder": "Enter AWB Numbers",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("Use Comma(,) for Multiple AWB Numbers")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "AWB"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB')),
      expression: "errors.has('AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB Number is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-controls"
  }, [_c('div', {
    staticClass: "isactive"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isactive),
      expression: "isactive"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "isactive",
      "disabled": _vm.DisabledsAllFeild
    },
    domProps: {
      "checked": Array.isArray(_vm.isactive) ? _vm._i(_vm.isactive, null) > -1 : (_vm.isactive)
    },
    on: {
      "change": function($event) {
        _vm.isActiveCheck($event)
      },
      "__c": function($event) {
        var $$a = _vm.isactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isactive = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isactive = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "isActiveWarning"
  }, [_vm._v(_vm._s(this.checkboxWarning))])]), _vm._v(" "), _c('div', {
    staticClass: "filter-action-buttons"
  }, [_c('button', {
    staticClass: "btn btn-danger action-btn",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Reset")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary action-btn export-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.ExportDisableds
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportfileCSV()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Export")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success action-btn search-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Search")])])])])])])]), _vm._v(" "), (!_vm.show2 && (!_vm.isLoading1 || _vm.totalcount === 0)) ? _c('div', {
    staticClass: "investigation-empty-state"
  }, [_vm._m(2), _vm._v(" "), _c('h3', [_vm._v("No Search Results")]), _vm._v(" "), _c('p', [_vm._v("Adjust your filters above and click \"Search\" to view shipment details.")])]) : _vm._e(), _vm._v(" "), (_vm.isLoading1) ? _c('div', {
    staticClass: "col-12 p-0"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.show2,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#000080"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipment Details "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("(Total Records :" + _vm._s(_vm.totalcount) + ")")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Investigation Aging")]), _vm._v(" "), _c('span', {
    staticClass: "sort-icons"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    class: {
      active: _vm.sortColumn === 'pendingdays' && _vm.sortDirection === 'asc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('pendingdays', 'asc')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-down",
    class: {
      active: _vm.sortColumn === 'pendingdays' && _vm.sortDirection === 'desc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('pendingdays', 'desc')
      }
    }
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OctroiMRP")]), _vm._v(" "), _c('span', {
    staticClass: "sort-icons"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    class: {
      active: _vm.sortColumn === 'netvalue' && _vm.sortDirection === 'asc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('netvalue', 'asc')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-down",
    class: {
      active: _vm.sortColumn === 'netvalue' && _vm.sortDirection === 'desc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('netvalue', 'desc')
      }
    }
  })])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Logged Date")]), _vm._v(" "), (_vm.showSort) ? _c('div', [_c('div', [_c('i', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.sortingEvent($event, 'Asc')
      }
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-arrow-down",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.sortingEvent($event, 'Desc')
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33)])]), _vm._v(" "), (_vm.editshowtable) ? _c('tbody', [(_vm.totalcount == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "colspan": "31",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedList), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.bucketname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(!data.isactive && data.actionstatuscode === '38') ? _c('span', [_vm._v("0")]) : ((!data.isactive)) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("CLOSED")]) : _vm._e(), _vm._v(" "), ((data.isactive)) ? _c('span', [_vm._v(_vm._s(data.pendingdays))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.goSummeryPage(data.shippingid)
        }
      }
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.showMpsDetails(data.multishipmentgroupid)
        }
      }
    }, [_vm._v(_vm._s(data.multishipmentgroupid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.netvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.disputeamount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.regionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.finaldestinationname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.disputemarkedonhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientreason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientsubreason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.loggeddescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.VerificationStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ordertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.phyweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.volweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddate ? new Date(data.createddate).toLocaleDateString() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.approvaldescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.coloaderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.bagcondition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productinformation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Statusname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.disputstatusname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.stdbagcondition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddate ? new Date(data.createddate).toLocaleDateString() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shortagetype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.recreasionname))]), _vm._v(" "), (_vm.abc == '' || _vm.abc !== data.shippingid) ? _c('td', [_c('b-link', {
      staticClass: "btn btn-sm btn-info",
      on: {
        "click": function($event) {
          _vm.ImageView(data.shippingid, data.status)
        }
      }
    }, [_c('i', {
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("View")])], 1) : (_vm.abc !== '' || _vm.abc == data.shippingid) ? _c('td', [_vm._l((_vm.List), function(d) {
      return _c('div', [_c('b-link', {
        on: {
          "click": function($event) {
            _vm.downloadImage(d.Key ? d.Key : (d.url ? d.url : d))
          }
        }
      }, [_c('i', {
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("Image")])], 1)
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "13px"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.errormsg) + "\n                  ")])], 2) : _vm._e()])
  })], 2) : _vm._e()])]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF0000"
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "active": _vm.show1,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#00FFFF"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgData,
      "alt": "loading..."
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "mpsPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.isMpsDetails),
      callback: function($$v) {
        _vm.isMpsDetails = $$v
      },
      expression: "isMpsDetails"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isMpsDetailsLoading,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#00FFFF"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.closeMpsDetails()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables mpsTable"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Shipping Id")]), _vm._v(" "), _c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v("Shipment Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mpsDetailsShipments), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentstatus))])])
  }))])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "investigation-page-header"
  }, [_c('div', {
    staticClass: "investigation-page-title"
  }, [_c('div', {
    staticClass: "title-icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("Investigation Shipments Details")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "isactive"
    }
  }, [_c('b', [_vm._v("isActive")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-icon"
  }, [_c('i', {
    staticClass: "fa fa-search-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending At")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB Number")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("MPS ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin HubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination HubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Marked On Facility")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Reason")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Sub-Reason")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Verification Action")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPS Logged By")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Physical Weight")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Volumetric Weight")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Logged Desc")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Service (Coloader/Vendor)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bag Condition")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Desc")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Status Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPSBag Condition")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Modified By")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Manifest InScan Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shortage Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bag No")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("REC Reason")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78cc5823","hasScoped":true}!./src/views/components/investigationDefault/investigationDefault.component.html
// module id = 479
// module chunks = 1